let _state = {};

export const setState = state => (_state = state);
export const getState = () => _state;
